import { api } from '../../plugins/api';

const getDefaultState = () => {
	return {
		scolarites: []
	}
}

const state = getDefaultState()

const getters = {
  GET_ALL_SCOLARITES: (state) => { return state.scolarites },
  GET_SCOLARITES: (state) => { return state.scolarites.filter(f => !f.deleted || f.deleted != true) },
}

const mutations = {
	SET_SCOLARITE (state, scolarites) {
		state.scolarites = scolarites != null ? scolarites : [] // TODO voir pq erreur
	},
  SET_SCOLARITE_ID (state, payload) {
    payload.element.id = payload.id
	},
	ADD_SCOLARITE (state, scolarite) {
		state.scolarites.push(scolarite)
	},
	REMOVE_SCOLARITE (state, scolarite) {
    state.scolarites.splice(state.scolarites.indexOf(scolarite), 1);
    if (scolarite?.id != null) {
      scolarite.deleted = true;
      state.scolarites.push(scolarite)
    }
	},
	UPDATE_SCOLARITE(state, scolarite) {
    state.scolarites[state.scolarites.indexOf(state.scolarites.find(a => a.id == scolarite.id))] = scolarite
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async getScolaritesByDemandeAdmissionId ({ commit }, demandeAdmissionId) {
		const response = await api.get(`scolarites/demandesadmissions/` + demandeAdmissionId);
		commit("SET_SCOLARITE", response.data ? response.data : [])
	},
	async updateScolarite ({ commit }, scolarite) {
		const response = await api.put(`scolarites`, scolarite);
		commit("UPDATE_SCOLARITE", response.data)
	},
  async createScolarite ({ commit }, scolarite) {
		const response = await api.post(`scolarites`, scolarite);
		if (response.data) {
			commit("SET_SCOLARITE_ID", { element: scolarite, id: response.data });
		}
	},
	async deleteScolarite ({ commit }, id) {
		const response = await api.delete(`scolarites/` + id);
		if (response.data == true) {
			commit("REMOVE_SCOLARITE", this.getters["Scolarite/GET_SCOLARITES"].find(a => a.id == id))
		}
	},
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})